import React from "react";
import VisitingCard from "../VisitingCard";
import Bigcard from "../BigCard";
import PapperCard from "../PapperCard";
import FoldableCard from "../FoldableCard";
import Style from "../VerifyCertificate.module.scss";
import useVerifyWithNumber from "./useVerifyWithNumber";
import Assets from "../../../assets/Assets";

const VerifyWithNumber = () => {
  const {
    error,
    certificateData,
    handleSubmit,
    handleChange,
    certificateId,
    isDownloading,
    handleDownloadOldCertificate,
  } = useVerifyWithNumber();

  return (
    <div>
      {/* commented as per client request */}
      <div className="row gx-2 pro-pt-6 pro-px-6 pro-justify-center  ">
        <div className="col-md-4 pro-d-flex pro-gap-3">
          <input
            className="pro-input"
            onChange={handleChange}
            value={certificateId}
            placeholder={"Enter certificate Number"}
            disabled
          />
          {/* <button
            className=" pro-btn pro-btn-primary"
            type="button"
            onClick={handleSubmit}
          >
            {" "}
            Submit{" "}
          </button> */}
        </div>
      </div>
      {!!error ? (
        <div className=" pro-d-flex pro-justify-center pro-w-100 pro-pt-5 ">
          <h5 className="error-custom">{error}</h5>
        </div>
      ) : (
        <div className="pro-mt-5">
          <div>
            {certificateData?.old_certificate === true ? (
              certificateData?.file_path && (
                <div className="pro-d-flex pro-flex-column pro-items-center pro-w-100 pro-px-3">
                  <img
                    src={certificateData.file_path}
                    alt="Old certificate"
                    className={Style.old_certificate_img}
                  />
                  <div className="pro-d-flex pro-justify-center pro-pt-3 pro-gap-3">
                    <button
                      className="pro-btn pro-btn-primary pro-px-5"
                      onClick={handleDownloadOldCertificate}
                      type="button"
                      disabled={isDownloading}
                    >
                      {isDownloading ? "Loading..." : "Download"}
                    </button>
                  </div>
                  <p className="pro-pt-3">
                    For more details,{" "}
                    <a
                      href="https://igjiglobal.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      click here
                    </a>
                  </p>
                  <a
                    href="https://igjiglobal.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={Style.logo_link}
                  >
                    <figure>
                      <img src={Assets.IGJI_LOGO} alt="IGJI" />
                    </figure>
                  </a>
                </div>
              )
            ) : (
              <>
                {certificateData?.certificate_type === 1 && (
                  <VisitingCard data={certificateData} />
                )}
                {certificateData?.certificate_type === 2 && (
                  <Bigcard data={certificateData} />
                )}
                {certificateData?.certificate_type === 3 && (
                  <PapperCard data={certificateData} />
                )}
                {certificateData?.certificate_type === 4 && (
                  <FoldableCard data={certificateData} />
                )}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default VerifyWithNumber;
